import './ResponseRateBox.css';

interface ResponseRateBoxProps {
  rate: number | null;
  label: string;
  color: string;
}

const ResponseRateBox = ({ rate, label, color }: ResponseRateBoxProps) => (
  <div className="response-rate-box" style={{ backgroundColor: color }}>
    <span className="response-rate-box-percentage">{rate !== null ? `${rate}%` : 'N/A'}</span>
    <span className="response-rate-box-label">{label}</span>
  </div>
);

export default ResponseRateBox;
